import { useCallback, useEffect, useState } from "react";
import { getResumen } from "../../../services/backend/cotizacionService";
import logger from "../../../shared/utils/logger";

const useCheckoutSummary = ({ cotizacionId }) => {
  const [checkoutResumen, setCheckoutResumen] = useState(null);

  const refreshCheckoutSummary = useCallback(async (targetCotizacionId) => {
    const id = String(targetCotizacionId || cotizacionId || "").trim();
    if (!id) {
      setCheckoutResumen(null);
      return;
    }
    try {
      const resumenResponse = await getResumen(id, 0, false);
      setCheckoutResumen(resumenResponse || null);
    } catch (error) {
      logger.error("No fue posible obtener el resumen del checkout.", error);
      setCheckoutResumen(null);
    }
  }, [cotizacionId]);

  useEffect(() => {
    refreshCheckoutSummary();
  }, [refreshCheckoutSummary]);

  return {
    checkoutResumen,
    refreshCheckoutSummary,
  };
};

export default useCheckoutSummary;